"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var combobox_1 = require("@reach/combobox");
var SuggestionsList = function (_a) {
    var data = _a.data, popoverClassName = _a.popoverClassName, value = _a.value;
    if (!data.length) {
        return null;
    }
    return (react_1.default.createElement(combobox_1.ComboboxPopover, { className: popoverClassName },
        react_1.default.createElement(combobox_1.ComboboxList, { "aria-label": "Places" }, data.map(function (_a) {
            var place_id = _a.place_id, structured_formatting = _a.structured_formatting, description = _a.description;
            var main_text = structured_formatting.main_text, secondary_text = structured_formatting.secondary_text;
            var formatText = main_text.replace(new RegExp('(' + value + ')', 'gi'), '<span data-reach-combobox-option-text data-user-value="true">$1</span>');
            return (react_1.default.createElement(combobox_1.ComboboxOption, { id: place_id, key: place_id, value: description },
                react_1.default.createElement("div", { className: "cb-option-inner" },
                    react_1.default.createElement("span", { className: "place-icon" },
                        react_1.default.createElement("i", { className: "cm-icon icon-location" })),
                    react_1.default.createElement("div", { className: "place-info" },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: formatText,
                            } }),
                        react_1.default.createElement("div", { className: "secondary-text" }, secondary_text)))));
        }))));
};
exports.default = SuggestionsList;
